import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction, LazyImport, registerLazyOrchestrator } from "owa-bundling";
import { fetchIsMeetingSummaryWorthy } from "./actions/publicActions";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotMeetingIsSummaryWorthy" */ "./lazyIndex"), { name: "CopilotMeetingIsSummaryWorthy" });

// Lazy Actions
export const lazyFetchIsMeetingSummaryWorthyAction: LazyAction<typeof lazyIndex.fetchIsMeetingSummaryWorthy, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchIsMeetingSummaryWorthy);

// Selectors
export const lazygetMeetingSummaryWorthyMetaData: LazyImport<typeof lazyIndex.getMeetingSummaryWorthyMetaData, typeof lazyModule> = new LazyImport(lazyModule, m => m.getMeetingSummaryWorthyMetaData);

//Orchestrator
registerLazyOrchestrator(fetchIsMeetingSummaryWorthy, lazyModule, m => m.fetchIsMeetingSummaryWorthyOrchestrator);

// Util
export const lazyFetchIsMeetingSummaryWorthyUtil: LazyAction<typeof lazyIndex.fetchIsMeetingSummaryWorthyUtil, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchIsMeetingSummaryWorthyUtil);

export { checkSummaryWorthy } from "./helpers";
export { summaryWorthyCompletionObserved, type SummaryWorthyCompletionObservation, type SummaryWorthyCompletionObservationActionMessage, type SummaryWorthyCompletionOutcome, } from "./actions/completionActions";
export { default as RequestStatus } from "./store/schema/RequestStatus";
export { default as IsSummaryWorthyViewState } from "./store/schema/IsSummaryWorthyViewState";
